import React, { useEffect, useState } from "react";
import { useAuth0 } from '@auth0/auth0-react';
import apiUrl from "../Apiurl";


function CorreggiBrand(props) {

    //const [brand, setBrand] = useState("")
    const [correzione, setCorrezione] = useState("")

    const { user, /* isAuthenticated, */ getAccessTokenSilently } = useAuth0();

    const [token, setToken] = useState("");

    const brand = props.brand
    const setBrand = props.setBrand
    const listaBrand = props.listaBrand

    useEffect(() => {
        const getUserMetadata = async () => {
     
          try {
            const accessToken = await getAccessTokenSilently();
            setToken(accessToken);
          } catch (e) {
            console.log(e.message);
          }
        };
     
        getUserMetadata();


      }, [getAccessTokenSilently, user?.sub]);

    //const [variabili, setVariabili] = useState({});

    /* useEffect(() => {
        //copiare anche qui la stessa cosa che fa la funz da tradurre o non far visualizzare niente
        fetch(apiUrl + "/prodotti/ps/variabili")
            .then(resp => resp.json())
            .then(data => setVariabili(data))
    }, []); */


    ///// PAGINA

    function handleChangeBrand(evt) {
        const value = evt.target.value;
        //const evtName = evt.target.name;
        //console.log("NAME: "+evtName);
        //console.log("VALUE: "+value);
        setBrand(value)
    }

    function handleChangeCorrezione(evt) {
        setCorrezione(evt.target.value);
    }

    function submitCorrezione(evt) {
        fetch(apiUrl + "/patch/brand", {
            method: 'PATCH', // or 'PUT'
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer '+token
            },
            body: JSON.stringify({
                brandDaCorreggere: brand,
                correzioneBrand: correzione
            }),
        })
            .then(response => response.json())
            .then(data => {
                console.log('Success:', data);
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    }





    return (
        <section className="ph3 ph5-ns pv5 b--white">
            <article className="mw8 center br2 ba b--white">
                <div className="dt-ns dt--fixed-ns w-100 b--white">
                <form>
                    {/* <fieldset className='b--white'> */}
                        <h2>Correzione nomi brand</h2>
                        <p>Seleziona dalla tendina il brand da correggere e scrivi il nome corretto nel box sottostante</p>
                        <legend className=''>Lista brand presenti in DB</legend>
                        <select className='mt2' name="listaBrand" onChange={handleChangeBrand}>
                            {listaBrand.map((brandInLista) => {
                                if (brandInLista === brand) {
                                    return (
                                        <option value={brandInLista} selected="selected">{brandInLista}</option>
                                    )
                                } else {
                                    return (
                                        <option value={brandInLista}>{brandInLista}</option>
                                    )
                                }
                            })}
                        </select>
                    {/* </fieldset> */}
                    <br />
                    <input
                        className="mt3 mb2 db w-100 measure ba bordoColScrittaDef-20 pa2 br2"
                        type="text"
                        onChange={handleChangeCorrezione}
                        value={correzione}
                        autoComplete="off"
                    ></input>
                </form>
                <button onClick={submitCorrezione}>Cambia {brand} in {correzione}</button>
                </div>
            </article>
        </section>
    )
}

export default CorreggiBrand;

